import {ariaLabelDate} from '@github-ui/aria-label-date'

export function commentLabel(
  authorLogin: string | undefined,
  createdAt: string,
  kind: 'comment' | 'review' = 'comment',
) {
  return `${authorLogin ? `${authorLogin}'s ` : ''}${kind}, ${ariaLabelDate(new Date(createdAt))}`
}
